// extracted by mini-css-extract-plugin
module.exports = {"sales_leader":"_0fce717cdb--sales_leader--3sF4V","sales_leader-arrow":"_0fce717cdb--sales_leader-arrow--bEiu4"};